import { useMemo } from 'react';
import { getDeviationUrl } from '../_helpers';
export function useDeviationSeoData(deviation) {
    return useMemo(()=>{
        var _deviation_author;
        const author = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username;
        const isAi = deviation.isAiGenerated;
        return Object.fromEntries(Object.entries({
            creator: author !== null && author !== void 0 ? author : 'Anonymous',
            creditText: author ? `${author} on DeviantArt` : `DeviantArt`,
            license: deviation.license && deviation.license.startsWith('by-') && `http://creativecommons.org/licenses/${deviation.license}/3.0/`,
            acquireLicensePage: !isAi && getDeviationUrl(deviation),
            copyrightNotice: !isAi && author
        }).filter(([key, val])=>!!val));
    }, [
        deviation
    ]);
}
